module.exports = __webpack_public_path__ + "img/yw3.27ad4b50.png";